import { gql } from '@src/__generated__';

export const GET_PROMPTS = gql(`
  query GetPrompts {
    getPrompts {
      id
      promptKey
      label
      description
      content
      version
      isActive
      everActive
      createdAt
    }
  }
`);

export const GET_PROMPT_VERSIONS = gql(`
  query GetPromptVersions($promptKey: String!) {
    getPromptVersions(promptKey: $promptKey) {
      id
      promptKey
      label
      description
      content
      version
      isActive
      everActive
      createdAt
    }
  }
`);

export const UPDATE_PROMPT = gql(`
  mutation UpdatePrompt($promptKey: String!, $content: String!) {
    updatePrompt(promptKey: $promptKey, content: $content) {
      id
      promptKey
      label
      content
      version
      isActive
      everActive
      createdAt
    }
  }
`);

export const SET_ACTIVE_PROMPT_VERSION = gql(`
  mutation SetActivePromptVersion($id: ID!) {
    setActivePromptVersion(id: $id) {
      id
      promptKey
      version
      isActive
      everActive
    }
  }
`);

export const DISCARD_PROMPT_DRAFT = gql(`
  mutation DiscardPromptDraft($id: ID!) {
    discardPromptDraft(id: $id)
  }
`);
